import { HttpEvent } from '@angular/common/http';
import { inject, Injectable, WritableSignal } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiResponse, trackUploadProgress } from '@app/core/api';
import { FileCategory } from '@app/core/types/enums/file-category.enum';
import { toUploadFileFormData } from '@app/core/types/upload-file.dto';
import { UploadFileResult } from '@app/core/types/upload-file-result.interface';

import { FileApiService } from './file-api.service';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root',
})
export class FileUploadService {
  private readonly fileApi = inject(FileApiService);
  private readonly tokenService = inject(TokenService);

  upload(
    file: File,
    category: FileCategory,
    progress?: WritableSignal<number>,
  ): Observable<UploadFileResult> {
    const userId = this.tokenService.getUserId();

    if (!userId) {
      return throwError(() => new Error('UserId not found in access token'));
    }

    const formData = toUploadFileFormData({ file, category }, userId);

    return trackUploadProgress(
      this.fileApi.uploadFile(formData) as unknown as Observable<HttpEvent<ApiResponse<UploadFileResult>>>,
      progress,
    ).pipe(map(response => response.result));
  }
}
